export default __webpack_public_path__ + "10a18551cf14b131c33f1b79dff875f2.svg";